<template>
    <div class="account">
        <div class="container">
            <div class="account__wrapper">
                <AccountSideMenu></AccountSideMenu>

                <div class="account__contain settings">
                    <h5 class="account__section-title">PIN konto rodzica</h5>

                    <div class="settings__wrapper">
                        <div class="settings__pin" v-if="!isPinChange">
                            <label for="pin" class="input-text">
                                <span class="input-text__label">PIN:</span>
                                <input class="input-text__input"  type="text" name="pin" id="pin" value="* * * *" disabled>
                            </label>

                            <span class="settings__change-pin" @click="isPinChange = !isPinChange">Zmień PIN</span>
                        </div> 

                        <ModulePinChange class="settings__pins" v-if="isPinChange" @closeModule="closeModule"></ModulePinChange>
                    </div>      

                    <div class="consent" v-if="consent">
                        <h5 class="account__section-title">Zgody</h5>
                        <div class="consent__wrapper">

                            <InputCheckbox
                                class="consent__checkbox"
                                :name="'consent'"
                                :label="'Zgoda na przetwarzanie danych dzieci w aplikacji'"
                                :data="consent"
                                @setCheckboxValue="changeConsent">
                            </InputCheckbox>

                            <span class="consent__info"><IconI></IconI> wycofanie poprzez wyłączenie powyższej zgody wiąże się z bezpowrotnym usunięciem wszystkich profili dzieci w aplikacji Kraina ABC</span>
                        </div>
                    </div>

                    <div class="privacy">
                        <h5 class="account__section-title">Prywatność</h5>
                        
                        <div class="privacy__items">
                            <a href="/polityka" target="_blank" class="privacy__item">
                                <IconPrivacyPolicy class="privacy__icon"></IconPrivacyPolicy>
                                <span class="privacy__text">Polityka prywatności</span>
                            </a>

                            <a href="/regulamin" target="_blank" class="privacy__item">
                                <IconRules class="privacy__icon"></IconRules>
                                <span class="privacy__text">Regulamin aplikacji</span>
                            </a>
                        </div>
                    </div>

                    <div class="privacy">
                        <h5 class="account__section-title">Konto</h5>
                        <a href="https://user.tvp.pl/account.php?action=settings&mode=normal" class="settings__link">Zarządzaj danymi na koncie TVP</a>
                        <a href="https://user.tvp.pl/account.php?action=delete&mode=normal" class="settings__link settings__link--remove">Usuń konto TVP</a>
                    </div>
                </div>
            </div>
        </div>

        <ModalConfirm v-if="isModalConfirm" :title="confirmTitle" :text="confirmText" :btnAccept="btnAccept" :btnReject="btnReject" @confirmHandle="confirmHandle"></ModalConfirm>
    </div>
</template>

<script>
import axios from "axios";
import AccountSideMenu from "./AccountSideMenu.vue";
import ModulePinChange from "../modules/ModulePinChange";
import IconPrivacyPolicy from "../elements/icons/IconPrivacyPolicy.vue";
import IconRules from "../elements/icons/IconRules.vue";
import IconI from "../elements/icons/IconI.vue";
import InputCheckbox from "../profile/InputCheckbox.vue";
import ModalConfirm from "../modals/ModalConfirm.vue";
import { useCookies } from "vue3-cookies";
import { useToast } from "vue-toastification";

const toast = useToast()
const { cookies } = useCookies();

export default {
    name: "AccountSettings",
    components: {
        AccountSideMenu,
        ModulePinChange,
        IconPrivacyPolicy,
        IconRules,
        IconI,
        InputCheckbox,
        ModalConfirm
    },
    data() {
        return {
            CONSENT_DISALLOW: '/api/krainaabc/account/user-application-data/consent-disallow?device=www',
            isPinChange: false,
            newPin: '',
            newPinRepeat: '',
            newPinError: '',
            newPinRepeatError: '',
            pinError: '',
            showPin: false,
            showPinRepeat: false,
            consent: false,
            isModalConfirm: false,
            confirmText: 'Wycofanie zgody na przetwarzanie danych dzieci w aplikacji wiąże się z bezpowrotnym usunięciem wszystkich profili dzieci w aplikacji Kraina ABC. Czy na pewno chcesz wycofać zgodę?',
            confirmTitle: 'Wycofanie zgody',
            btnAccept: 'Wycofaj zgodę',
            btnReject: 'Nie wycofuj zgody'
        };
    },
    computed: {
        path() {
            return this.$route.path;
        },
        getPinLock() {
            return this.$store.getters.getPinLock;
        },
        getPinLockChild() {
            return this.$store.getters.getPinLockChild;
        },
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        },
        globalUserData() {
            return this.$store.getters.getGlobalUserData;
        }
    },
    watch: {
        globalUserData(value) {
            if(value && value.subprofile_process_consent) {
                this.consent = true;
            } else {
                this.consent = false;
            }
        }
    },
    methods: {
        closeModule({success}) {
            if(success) {
                if(this.getPinLockChild && this.getPinLockChild.subProfile && this.getPinLockChild.subProfile._id) {
                    this.$store.dispatch("changePinLockChild", { mode: 'unlock', subProfile: this.getPinLockChild.subProfile });
                }

                if(this.getPinLock && this.getPinLock.path) {
                    cookies.remove("parent_lock");
                    this.$router.push({
                        path: this.getPinLock.path
                    });                        
                }
            }
            this.isPinChange = false;
        },
        changeConsent(value) {
            if(this.consent && !value) {
                this.isModalConfirm = true;
                this.$store.dispatch("changeModalBackdrop", true);
            }
        },
        confirmHandle(value) {
            this.isModalConfirm = false;
            this.$store.dispatch("changeModalBackdrop", false);

            if(value) {
                this.saveConsentDisallow();
                this.consent = false;
            } else { 
                this.consent = true;
            }
        },
        saveConsentDisallow() {
            axios
                .post(this.CONSENT_DISALLOW)
                .then((response) => {
                    if(response.data.data.success) {
                        toast.success("Zgody zostały wycofane"); 
                        this.$store.dispatch('globalUserData');
                    } else {
                        toast.error("Nie udało się wycofać zgód");
                    }
                })
                .catch(() => {
                    toast.error("Nie udało się wycofać zgód");
                }); 
        },         
    },
    mounted() {
        window.gemius_event(
            '_view_',
            this.gemiusIdentifier
        );      

        if(this.globalUserData && this.globalUserData.subprofile_process_consent) {
            this.consent = true;
        } else {
            this.consent = false;
        }
    }
};
</script>